export default __webpack_public_path__ + "static/media/video-cover.9ba47be7.png";